var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuboardClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4498 6.56976L13.9223 16.7173C13.7423 17.4748 13.0673 17.9998 12.2873 17.9998H2.43229C1.29979 17.9998 0.489806 16.8897 0.827306 15.8022L3.9848 5.66229C4.2023 4.95729 4.85481 4.46973 5.58981 4.46973H14.8148C15.5273 4.46973 16.1198 4.90473 16.3673 5.50473C16.5098 5.82723 16.5398 6.19476 16.4498 6.56976Z",
    stroke: "#EA1D63",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H15.585C16.5525 18 17.31 17.1825 17.2425 16.215L16.5 6",
    stroke: "#EA1D63",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25781 6.28488L8.03782 3.04492",
    stroke: "#EA1D63",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2812 6.29208L12.9863 3.03711",
    stroke: "#EA1D63",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77344 10.5H11.7734",
    stroke: "#EA1D63",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02344 13.5H11.0234",
    stroke: "#EA1D63",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.5C21 5.9 20.95 6.28749 20.85 6.66249C20.7375 7.16249 20.5375 7.65 20.275 8.075C19.4125 9.525 17.825 10.5 16 10.5C14.7125 10.5 13.55 10.0125 12.675 9.21246C12.3 8.88746 11.975 8.5 11.725 8.075C11.2625 7.325 11 6.4375 11 5.5C11 4.15 11.5375 2.91253 12.4125 2.01253C13.325 1.07503 14.6 0.5 16 0.5C17.475 0.5 18.8125 1.13752 19.7125 2.16252C20.5125 3.05002 21 4.225 21 5.5Z",
    fill: "#FFE0EB",
    stroke: "#EA1D63",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2859 4.1748L14.6484 6.81229",
    stroke: "#EA1D63",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6719 4.2002L17.3219 6.83768",
    stroke: "#EA1D63",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuboardClose);
export default __webpack_public_path__ + "static/media/menuboard-close.717116cb2dca489c7158beaf7a67db05.svg";
export { ForwardRef as ReactComponent };